import { StreamData } from 'types/streamData'
import { FieldResolver } from '../fieldResolver'
import { Metadata } from '../../adaptor/metadata'

const interestsResolver: FieldResolver = (metadata: Metadata) =>
  ({ interests: metadata.getInterests() } as StreamData)

export default interestsResolver
